export enum JobSearchMatchType {
    ExactMatch = 0,
    CloseMatch = 1,
    NotMatch = 2,
}